export function clickFilterItemPoint(stateUserId, typeName) {
  // 筛选项按钮click
  window.__XES_LOG__?.clickMsg({
    params: {
      data_clickid: "1.3.1",
      user_id: stateUserId,
      scalp_type: typeName,
    },
  });
}

export function showFilterSelectPonit(stateUserId, type, typeName, tagList) {
  window.__XES_LOG__?.loadMsg({
    data_pageid: "1.3.3",
    user_id: stateUserId,
    scalp_type: type,
    scalp_type_name: typeName,
    tagList: tagList,
  });
}

export function clickFilterSelectItemPoint(stateUserId, id, name, tagType) {
  window.__XES_LOG__?.clickMsg({
    params: {
      data_clickid: "1.3.2",
      user_id: stateUserId,
      scalp_type: tagType,
      cur_name: name,
      cur_id: id,
    },
  });
}

export function clickChangeOriginalCoursePoint(
  stateUserId,
  coursePackageInfoItem,
  courseId
) {
  // 是否原班
  window.__XES_LOG__.clickMsg({
    params: {
      data_clickid: "1.3.4",
      user_id: stateUserId,
      class_type: coursePackageInfoItem.originalCourse ? "原班推荐" : "非原班", // 课程类型 是否为原班推荐
      course_id: courseId, // 课程id
    },
  });
}

export function loadCourseListPoint(stateUserId, courseId, currentCourseId) {
  window.__XES_LOG__?.loadMsg({
    data_pageid: "1.3.1",
    user_id: stateUserId, // 用户id
    course_id: courseId, // 所有的课程ID
    original_course_id: currentCourseId, // 原班的课程ID
  });
}

// 共用埋点参数
export function getCommonLog(package_info) {
  const course = (package_info?.product_list || []).find(
    (item) => item.type === 100
  );
  const params = {
    subject_name: course?.extra_info?.subject_name || "",
    grade_name: course?.extra_info?.grade_names || "",
    commodity_type: package_info?.product_type,
    commodity_name: package_info?.name,
    commodity_id: package_info?.product_id,
    ...(package_info?.promotion_id && {
      promotion_id: package_info?.promotion_id,
    }),
  };
  if (package_info.isAddPriceBuy) {
    const parent_id = (package_info?.parent || "").split("_")?.[1];
    params.related_main_product_id = parent_id;
    params.default_check_states = package_info.default_check_states ? 1 : 2;
    params.respos_card_type = package_info.addPriceBuyIndex + 1;
  }
  console.log("getCommonLog", package_info, params);
  return params;
}
